import { ButtonHTMLAttributes, ReactNode } from "react";

const Button = (
  props: { children?: ReactNode; transparent?: boolean } & ButtonHTMLAttributes<HTMLButtonElement>
) => {
  return (
    <button
      {...props}
      className={`${props.transparent ? "bg-transparent border-none outline-none" : ""} ${props.className}`}
      style={{
        ...props.style,
        pointerEvents: "all",
      }}
    >
      {props.children}
    </button>
  );
};

export default Button;
